/**
 * @file Spinner.js
 * @description Defines a Spinner component to indicate loading state across the application.
 * The spinner accepts a className prop primarily aimed at adjusting the height and width.
 *
 * @param {number} height - The height of the spinner.
 * @param {number} width - The width of the spinner.
 * @returns {JSX.Element} The Spinner component.
 */

import React from "react";
import styles from "./Spinner.module.scss";
import { useTheme } from "../../../store/ThemeContext";

const Spinner = ({ className, height, width }) => {
  const themeStyles = useTheme();
  return (
    <div
      className={`${styles.container} ${className}`}
      style={{ height, width }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        height="100%"
        width="100%"
        viewBox="0 0 81 81"
      >
        <defs>
          <linearGradient id="Gradient1" gradientTransform="rotate(90)">
            <stop
              offset="0%"
              stopColor={themeStyles?.accessoriesBg1 || "#1366FF"}
            />
            <stop
              offset="100%"
              stopColor={themeStyles?.accessoriesBg1 || "#1366FF"}
            />
          </linearGradient>
          <linearGradient id="Gradient2" gradientTransform="rotate(90)">
            <stop
              offset="0%"
              stopColor={themeStyles?.accessoriesBg1 || "#1366FF"}
              stopOpacity="0"
            />
            <stop
              offset="90%"
              stopColor={themeStyles?.accessoriesBg1 || "#1366FF"}
            />
            <stop
              offset="100%"
              stopColor={themeStyles?.accessoriesBg1 || "#1366FF"}
            />
          </linearGradient>
          <pattern
            id="Pattern"
            x="0"
            y="0"
            width="81"
            height="81"
            patternUnits="userSpaceOnUse"
          >
            <g transform="rotate(0, 40.5, 40.5)">
              <rect width="40.5" height="81" fill="url(#Gradient1)" />
              <rect x="40.5" width="40.5" height="81" fill="url(#Gradient2)" />
              <circle
                cx="103"
                cy="7"
                r="7"
                transform="rotate(-111.038 71.7096 28.1454)"
                fill={themeStyles?.accessoriesBg1 || "#1366FF"}
              />
            </g>
          </pattern>
        </defs>
        <path
          className="rotating"
          style={{ stroke: "url(#Pattern)" }}
          fill="transparent"
          strokeWidth="16"
          d="M 40.5 5 A 35.5 35.5 0 1 1 40.49 5"
        />
      </svg>
    </div>
  );
};
export default Spinner;
